'use client';

/**
 * FilterChips — horizontal row of single-select filter pills (course-type,
 * date-range filters, etc). The active key is owned by the parent (no
 * internal selection state) so it composes cleanly with URL/query-state.
 */
import { cn } from '@/lib/utils';

export interface FilterChip {
  key: string;
  label: string;
}

export interface FilterChipsProps {
  chips: FilterChip[];
  active: string;
  onSelect: (key: string) => void;
  className?: string;
}

export function FilterChips({
  chips,
  active,
  onSelect,
  className,
}: FilterChipsProps) {
  return (
    <div className={cn('flex flex-wrap gap-2', className)} role="group">
      {chips.map((chip) => {
        const isActive = chip.key === active;
        return (
          <button
            key={chip.key}
            type="button"
            onClick={() => onSelect(chip.key)}
            aria-pressed={isActive}
            className={cn(
              // Color transition merged with the shared press feel's
              // transform (see PRESSABLE's doc comment in design-tokens.ts
              // for why appending it wholesale here would clobber this).
              "flex h-8 items-center rounded-[17px] px-3.5 font-['Work_Sans'] text-[13px] font-semibold transition-[background-color,border-color,color,transform] duration-[160ms] ease-out motion-safe:active:scale-[0.96]",
              isActive
                ? 'bg-[#E36001] text-white'
                : 'border-[1px] border-[#eadfce] bg-white text-[#5b6072]'
            )}
          >
            {chip.label}
          </button>
        );
      })}
    </div>
  );
}
